import intersection from 'lodash-es/intersection'
import * as queryString from 'query-string'
import * as React from 'react'
import { RouteConfigComponentProps } from 'react-router-config'

import { searchFrontendParams } from '../../common/constants/searchQueryWhitelist'
import { IPageComponent } from '../../typings/pageComponent'
import CategoryPageContainer from '../containers/categoryPageContainer'
import SearchPageContainer from '../containers/searchPageContainer'

const hasSearchPageQueryParams = (query: any) =>
  !!intersection(Object.keys(query), searchFrontendParams).length

const SearchCategoryPageProxy: IPageComponent<
  RouteConfigComponentProps<any>
> = props => {
  const query = queryString.parse(props.location.search)
  if (hasSearchPageQueryParams(query)) {
    return <SearchPageContainer {...props} />
  } else {
    return <CategoryPageContainer {...props} />
  }
}

SearchCategoryPageProxy.loadData = ({
  store,
  location,
  apiUrlPrefix,
  apiAppUrlPrefix,
  routeMatch
}) => {
  if (hasSearchPageQueryParams(location.query)) {
    return (
      (SearchPageContainer.loadData &&
        SearchPageContainer.loadData({
          store,
          location,
          apiUrlPrefix,
          apiAppUrlPrefix,
          routeMatch
        })) ||
      Promise.resolve()
    )
  } else {
    return (
      (CategoryPageContainer.loadData &&
        CategoryPageContainer.loadData({
          store,
          location,
          apiUrlPrefix,
          apiAppUrlPrefix,
          routeMatch
        })) ||
      Promise.resolve()
    )
  }
}

SearchCategoryPageProxy.onBeforePageView = ({
  store,
  location,
  routeMatch,
  prevLocation
}) => {
  if (
    hasSearchPageQueryParams(location.query) &&
    typeof SearchPageContainer.onBeforePageView === 'function'
  ) {
    return SearchPageContainer.onBeforePageView({
      store,
      location,
      routeMatch,
      prevLocation
    })
  } else if (typeof CategoryPageContainer.onBeforePageView === 'function') {
    return CategoryPageContainer.onBeforePageView({
      store,
      location,
      routeMatch
    })
  }
}

export default SearchCategoryPageProxy
